(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slider-props"] && !Shopify.designMode) return;
  try {
    
(function () {
  var init = function (container) {
    var id = container.getAttribute('data-section-id');
    if (!id) return;

    var wrapper = document.getElementById('props-ba-' + id);
    if (!wrapper) return;

    var handle = document.getElementById('props-ba-handle-' + id);
    var beforeLayer = wrapper.querySelector('.props-before-after-layer--before');
    if (!handle || !beforeLayer) return;

    var initialPos = parseFloat(wrapper.getAttribute('data-initial')) || 50;
    var currentPos = 0;
    var isDragging = false;
    var wrapperRect = null;
    var hasAnimated = false;

    var clamp = function (val, min, max) {
      return Math.min(max, Math.max(min, val));
    };

    var setPosition = function (pct) {
      currentPos = clamp(pct, 0, 100);
      wrapper.style.setProperty('--props-ba-position', currentPos + '%');
      wrapper.setAttribute('aria-valuenow', Math.round(currentPos));
      wrapper.setAttribute('aria-valuetext', Math.round(currentPos) + ' percent showing before image');
    };

    setPosition(0);

    var animateIn = function () {
      if (hasAnimated) return;
      hasAnimated = true;
      wrapper.classList.add('is-animating');
      setPosition(initialPos);
      setTimeout(function () {
        wrapper.classList.remove('is-animating');
        wrapper.classList.add('is-ready');
      }, 650);
    };

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              animateIn();
              observer.unobserve(wrapper);
            }
          });
        },
        { threshold: 0.25 }
      );
      observer.observe(wrapper);
    } else {
      animateIn();
    }

    var getPosition = function (clientX) {
      if (!wrapperRect) wrapperRect = wrapper.getBoundingClientRect();
      var x = clientX - wrapperRect.left;
      return (x / wrapperRect.width) * 100;
    };

    var onStart = function (clientX) {
      isDragging = true;
      wrapperRect = wrapper.getBoundingClientRect();
      wrapper.classList.add('is-active');
      if (!wrapper.classList.contains('is-ready')) {
        wrapper.classList.add('is-ready');
      }
      setPosition(getPosition(clientX));
    };

    var onMove = function (clientX) {
      if (!isDragging) return;
      setPosition(getPosition(clientX));
    };

    var onEnd = function () {
      if (!isDragging) return;
      isDragging = false;
      wrapperRect = null;
      wrapper.classList.remove('is-active');
    };

    wrapper.addEventListener('mousedown', function (e) {
      e.preventDefault();
      onStart(e.clientX);
    });
    document.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      e.preventDefault();
      onMove(e.clientX);
    });
    document.addEventListener('mouseup', onEnd);

    wrapper.addEventListener(
      'touchstart',
      function (e) {
        if (e.touches.length === 1) {
          onStart(e.touches[0].clientX);
        }
      },
      { passive: true }
    );
    document.addEventListener(
      'touchmove',
      function (e) {
        if (!isDragging) return;
        if (e.touches.length === 1) {
          onMove(e.touches[0].clientX);
        }
      },
      { passive: true }
    );
    document.addEventListener('touchend', onEnd);
    document.addEventListener('touchcancel', onEnd);

    wrapper.addEventListener('keydown', function (e) {
      var step = 2;
      if (e.key === 'ArrowLeft' || e.key === 'Left') {
        e.preventDefault();
        setPosition(currentPos - step);
      } else if (e.key === 'ArrowRight' || e.key === 'Right') {
        e.preventDefault();
        setPosition(currentPos + step);
      }
    });
  };

  document.querySelectorAll('[data-section-type="props-before-after"]').forEach(init);

  document.addEventListener('shopify:section:load', function (e) {
    var c = e.target.querySelector('[data-section-type="props-before-after"]');
    if (c) init(c);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
